import { Popover, Flex, Input, Dropdown } from "antd"
import { PlusOutlined, HolderOutlined, FileDoneOutlined, MoreOutlined, ProjectOutlined, CaretDownFilled, CaretUpFilled, EditOutlined, CopyOutlined, DeleteOutlined } from "@ant-design/icons"
import DraggableItem from "./DraggableItem"
import { useState } from "react"
import { spaceColorBgMapping, sprintColorBgMapping } from "../../../utils/colorBgColorMap"
import { useTranslation } from 'react-i18next';


const SprintRow = (props) => {
    const { t } = useTranslation();
    const { sprint, sprintDetail, handleLabelChange, addSubLevel, removeSubLevel, deleteSprint, copySprint, updateSprintDuration, updateSprintColor } = props
    const [isOpen, setIsOpen] = useState(true)

    const handleColorChange = (color) => {
        updateSprintColor(sprint.uuid, color)
    }

    const colorIconPicker = (
        <div className="color-icon-picker">
            <div className="picker-header">
                <div className="text-weight-600">{t('Pick color')}</div>
            </div>
            <div className="color-row">
                <div className="color-box" style={{ backgroundColor: "#F5222D" }} onClick={() => handleColorChange("#F5222D")}>{sprint.color === "#F5222D" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#FA8C16" }} onClick={() => handleColorChange("#FA8C16")}>{sprint.color === "#FA8C16" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#FAAD14" }} onClick={() => handleColorChange("#FAAD14")}>{sprint.color === "#FAAD14" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#84CC16" }} onClick={() => handleColorChange("#84CC16")}>{sprint.color === "#84CC16" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#50A248" }} onClick={() => handleColorChange("#50A248")}>{sprint.color === "#50A248" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#13C2C2" }} onClick={() => handleColorChange("#13C2C2")}>{sprint.color === "#13C2C2" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#0A99FE" }} onClick={() => handleColorChange("#0A99FE")}>{sprint.color === "#0A99FE" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#141BCB" }} onClick={() => handleColorChange("#141BCB")}>{sprint.color === "#141BCB" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#722ED1" }} onClick={() => handleColorChange("#722ED1")}>{sprint.color === "#722ED1" && <ProjectOutlined style={{ color: "white" }} />}</div>
                <div className="color-box" style={{ backgroundColor: "#EB2F96" }} onClick={() => handleColorChange("#EB2F96")}>{sprint.color === "#EB2F96" && <ProjectOutlined style={{ color: "white" }} />}</div>
            </div>
        </div>
    )

    const databaseActions = [
        {
            key: "color",
            label: <Popover content={colorIconPicker} trigger={"click"} placement="right">
                <Flex gap={8} style={{ width: "120px" }}><EditOutlined /><span>{t('Change color')}</span></Flex>
            </Popover>
        },
        {
            key: "copy",
            label: <Flex gap={8} style={{ width: "120px" }}><CopyOutlined /><span>{t('Copy')}</span></Flex>,
            onClick: () => copySprint(sprint)
        },
        {
            key: "delete",
            label: <Flex gap={8} style={{ width: "120px" }}><DeleteOutlined /><span>{t('Delete')}</span></Flex>,
            danger: true,
            onClick: () => deleteSprint(sprint)
        },
    ]

    return (
        <div className="sprint-row resource-parent-row " style={{ flexDirection: "column" }}>
            <Flex className="estimation-row sprint-parent-row">
                <Flex className="left-section-row-data " gap={8}>
                    <Flex gap={5} className="sprint-action">
                        <HolderOutlined className="app-icon" style={{ marginRight: "5px" }} />
                        <PlusOutlined className="app-icon" onClick={() => addSubLevel(sprint.uuid)} />
                    </Flex>
                    <div className="sprint-input" style={{background: sprint.color ? spaceColorBgMapping[sprint.color] : "#E7F5FF"}}>
                        {
                            isOpen ? <CaretUpFilled style={{ color: sprint.color || "#0A99FE", marginRight: "5px" }} onClick={() => setIsOpen(false)} /> : <CaretDownFilled style={{ color: sprint.color || "#0A99FE", marginRight: "5px" }} onClick={() => setIsOpen(true)} />
                        }
                        <Input className="sprint-title" value={sprint.title} onChange={(e) => handleLabelChange('', sprint.uuid, e.target.value, 'sprint')} />
                    </div>
                    <FileDoneOutlined style={{ color: sprint.color ||  "#0A99FE" }} />
                    <Flex gap={5} className="sprint-action" align="center">

                        <Dropdown trigger={"click"} showArrow={false} menu={{ items: databaseActions }} placement="bottomRight">
                            <MoreOutlined className="app-icon" />
                        </Dropdown>
                    </Flex>
                </Flex>
                <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                    <DraggableItem allowResize={sprint.subLevels?.length ? false : true} sprints={props.sprints} currentSprint={sprint} sprintDetail={sprintDetail} {...props} />

                    {
                        [...Array(sprintDetail.duration)].map((e, i) => {
                            return <div className="week-block object-effort-block object-input" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div style={{ height: "40px" }}></div>
                            </div>
                        })
                    }
                </div>
            </Flex>
            {
                isOpen && sprint.subLevels && sprint.subLevels.map((sublevel, index) => {
                    return (
                        <Flex className="estimation-row">
                            <Flex className="sprint-sublevel-data" gap={8} style={{ padding: "0.25rem 0.75rem" }}>

                                <Flex gap={5} className="sprint-action">
                                    <HolderOutlined className="app-icon" style={{ marginRight: "5px" }} />
                                    <PlusOutlined className="app-icon" />
                                </Flex>
                                <Input size="large" className="sprint-sublevel" style={{ height: "100%", border: !sublevel.title ? "1px solid #D9D9D9" : "" }} value={sublevel.title} onChange={(e) => handleLabelChange(sublevel.uuid, sprint.uuid, e.target.value)} />
                                <Flex align="center" className="sprint-action">
                                    <DeleteOutlined className="app-icon delete-icon" onClick={() => removeSubLevel(sublevel.uuid, sprint.uuid)} />
                                </Flex>
                            </Flex>
                            <div className="add-sprint-item" style={{ display: "flex", width: "100%" }}>
                                <DraggableItem sprints={props.sprints} currentSprint={sublevel} sprintDetail={sprintDetail} isSubLevel={true} parentId={sprint.uuid} {...props} />

                                {
                                    [...Array(sprintDetail.duration)].map((e, i) => {
                                        return <div className="week-block object-effort-block object-input" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            <div style={{ height: "40px" }}></div>
                                        </div>
                                    })
                                }
                            </div>
                        </Flex>
                    )
                })
            }
        </div>
    )
}

export default SprintRow